import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface CrampingSectionProps {
  readonly currentPage: number;
}

export const CrampingSection: React.FC<CrampingSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 5 && (
        <SurveyQuestionCard
          sectionTag="CRAMPING"
          title="Have you had any cramping during dialysis recently?"
          required
        >
          <FormItemStyle
            name="Have you had cramping"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("haveYouHadCramping")}
              onChange={e => {
                localStorage.setItem("haveYouHadCramping", e.target.value);
              }}
            >
              <AnswerList>
                <AnswerOption value="NO">NO</AnswerOption>
                <AnswerOption value="Rarely (1 - 2 / Month)">
                  Rarely (1 - 2 / Month)
                </AnswerOption>
                <AnswerOption value="Occasional (3 - 4 / Month)">
                  Occasional (3 - 4 / Month)
                </AnswerOption>
                <AnswerOption value="Frequent (5 - 10 / Month)">
                  Frequent (5 - 10 / Month)
                </AnswerOption>
                <AnswerOption value="Every dialysis (11 - 13 / Month)">
                  Every dialysis (11 - 13 / Month)
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
    </>
  );
};
